"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var policy_1 = require("../policy");
var generator_1 = require("../generator");
var util_1 = require("../util");
var bridge_method_1 = require("../configuration/bridge-method");
var app_1 = require("./app");
var is_1 = require("./is");
var meta_1 = require("./meta");
var config_1 = require("./config");
var BaseBridge = (function () {
    function BaseBridge(communicationConfig, bridgeMethodsConfig, terminal) {
        this.call = util_1.noop;
        this.is = util_1.noop;
        this.config = {};
        this.app = {};
        this.meta = {};
        is_1.initIS(this);
        app_1.initApp(this);
        this.meta = meta_1.default;
        this.config = config_1.default;
        this.call = util_1.noop;
        this._communicationConfig = (terminal !== undefined && terminal !== this.app.env)
            ? null
            : policy_1.decideCommunication.call(this, communicationConfig, this.app);
        this._communication = generator_1.generateCommunication.call(this, this._communicationConfig, this.app);
        this._bridgeMethodsConfig = __assign({}, bridge_method_1.config, bridgeMethodsConfig);
        this._initCall();
    }
    BaseBridge.prototype.isSupport = function (method, module) {
        if (method === void 0) { method = ''; }
        if (module === void 0) { module = ''; }
        var isSupportCommunication = !!this._communicationConfig;
        if (!method || !isSupportCommunication) {
            return isSupportCommunication;
        }
        var bridgeMethodConfig = this._bridgeMethodsConfig[method] || {};
        var _isSupport = true;
        var supportHook = bridgeMethodConfig.isSupport || null;
        if (supportHook && supportHook(this.app)) {
            return _isSupport;
        }
        if (!supportHook) {
            _isSupport = true;
        }
        else {
            _isSupport = false;
        }
        module = module || bridgeMethodConfig.module || '';
        var WebViewUtilFusion = window.WebViewUtilFusion;
        if (this.app.communication === 'fusion' && WebViewUtilFusion) {
            var instance = module ? WebViewUtilFusion.loadModule(module) : WebViewUtilFusion;
            _isSupport = !!(instance && instance[method]);
        }
        return _isSupport;
    };
    BaseBridge.prototype._initCall = function () {
        var _this = this;
        this.call = function (method, params, callback, module) {
            if (callback === void 0) { callback = util_1.noop; }
            if (module === void 0) { module = ''; }
            if ((!callback || callback === util_1.noop) && typeof params === 'function') {
                callback = params;
                params = {};
            }
            return _this._call(method, params, callback, module);
        };
    };
    BaseBridge.prototype._call = function (method, params, callback, module) {
        var _this = this;
        var bridgeMethodArgsFactory = policy_1.decideBridgeArgs.call(this, this.app, this._bridgeMethodsConfig);
        var MultiCallArgs = bridgeMethodArgsFactory(method, params, callback, module);
        if (!this.isSupport(method, module)) {
            util_1.globalHandleError("The method \"" + method + "\" is not supported" + (module ? ' in module: ' + module : '') + ". It is recommended to check if it is supported by \"isSupport\" before calling the method. You can also contact the developers to check whether the built-in configuration of the method \"" + method + "\" is correct", this.app);
        }
        util_1.nextTick.call(this, function () {
            MultiCallArgs.forEach(function (arg) {
                _this._communication.apply(_this, arg);
            });
        });
    };
    return BaseBridge;
}());
exports.default = BaseBridge;
